import { render, staticRenderFns } from "./UserNotificationCreate.vue?vue&type=template&id=576bba76&"
import script from "./UserNotificationCreate.vue?vue&type=script&lang=js&"
export * from "./UserNotificationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports